// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'swipe-right-solid';

export const Component = () => (
  <path d='m21.121 7.37 3.4-3.161L21.121 1l-.67.814 2.107 1.916h-8.094v.958h8.094L20.45 6.65l.67.719ZM8.381 2.867c-.431.527-.622 1.102-.526 1.82v11.83l-3.496-2.442c-.623-.431-1.246-.479-1.868-.191-.67.239-1.15.814-1.39 1.676-.287.862-.19 1.677.336 2.442l5.411 6.37h13.793v-9.818l-7.902-2.97V4.688c0-.72-.239-1.341-.766-1.82a2.399 2.399 0 0 0-1.82-.814c-.67 0-1.245.287-1.772.814ZM0 3.777v1.006h5.89V3.777H0Z' />
);

export const viewBox = '0 0 25 25';
